// src\app\components\layout\CreateHeadersData.js:

import { KIND } from "../../modules/constants"
import { createLseCompaniesHeadersData } from "../layout/HomeTables/CreateLseCompaniesTableData"
import { createGovernanceHeadersData } from "../layout/HomeTables/CreateGovernanceTableData"
import { createLseCompaniesCommitteesHeadersData } from "../layout/HomeTables/createLseCompaniesCommitteesTableData"
import { createKeyDatesHeadersData } from "../layout/HomeTables/CreateKeyDatesTableData"
import { createLseBoardHeadersData } from "../layout/HomeTables/CreateBoardTableData"
import { createLsePeopleHeadersData } from "../layout/HomeTables/CreateLsePeopleTableData"
import { createLsePeopleCommitteesHeadersData } from "../layout/HomeTables/CreateLsePeopleCommitteesTableData"
import { createLseRolesHeadersData } from "../layout/HomeTables/CreateLseRolesTableData"
import { CreateLseRolesCommitteesHeaderData } from "../layout/HomeTables/CreateLseRolesCommitteesTableData"
import { createLseNewsHeadersData } from "../layout/HomeTables/CreateLseNewsTableData"
import { createFavouriteCompaniesHeaderData, createFavouritePeopleHeaderData } from "../layout/HomeTables/CreateFavouritesTableData"
import { createSearchCompaniesHeaderData, createSearchOfficersHeaderData } from "../layout/HomeTables/CreateSearchTableData"
import { createAdvisersHeadersData } from "../layout/HomeTables/CreateAdvisersTableData"
import { createAdvisersListHeadersData } from "../layout/HomeTables/CreateAdvisersListTableData"

const createHeadersData = props => {
  // console.log('createHeadersData props: ',props)
  switch (props.kind) {
    case KIND.SEARCH.OFFICERS:
    case KIND.SEARCH.DISQUALIFIED:
      return createSearchOfficersHeaderData(props)

    case KIND.FAVOURITE.COMPANIES:
      return createFavouriteCompaniesHeaderData(props)

    case KIND.FAVOURITE.PEOPLE:
      return createFavouritePeopleHeaderData(props)

    case KIND.LSE.COMPANIES.BOARD:
      return createLseBoardHeadersData(props)

    case KIND.LSE.COMPANIES.OVERVIEW:
      return createLseCompaniesHeadersData(props)

    case KIND.LSE.COMPANIES.GOVERNANCE:
      return createGovernanceHeadersData(props)

    case KIND.LSE.COMPANIES.COMMITTEES:
      return createLseCompaniesCommitteesHeadersData(props)

    case KIND.LSE.COMPANIES.DATES:
      return createKeyDatesHeadersData(props)

    case KIND.LSE.COMPANIES.ADVISERS:
      return createAdvisersHeadersData(props)

    case KIND.LSE.ROLES.BOARD:
      return createLseRolesHeadersData(props)

    case KIND.LSE.ROLES.COMMITTEES:
      return CreateLseRolesCommitteesHeaderData(props)

    case KIND.LSE.PEOPLE.BOARD:
      return createLsePeopleHeadersData(props)

    case KIND.LSE.PEOPLE.COMMITTEES:
      return createLsePeopleCommitteesHeadersData(props)

    case KIND.LSE.NEWS:
      return createLseNewsHeadersData(props)

    case KIND.LSE.ADVISERS:
      return createAdvisersListHeadersData(props)

    case KIND.SEARCH.COMPANIES:
    default:
      return createSearchCompaniesHeaderData(props)
  }
}

export default createHeadersData